import { useState } from 'react';
import RamadanButton from '../../../components/ramadan/RamadanButton';

export default function ContactSection() {
  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      details: ['HFC GYM, GO-DOWN, 9 Lulumba Ave, Eldoret'],
      link: 'https://www.google.com/maps/search/?api=1&query=HFC+GYM+GO-DOWN+9+Lulumba+Ave+Eldoret+Kenya'
    },
    {
      icon: 'ri-time-line',
      title: 'Operating Hours',
      details: ['Mon-Fri: 5:30 AM - 9:00 PM', 'Sat: 6:00 AM - 3:00 PM', 'Sun & Holidays: Closed']
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      details: ['0795 568 891'],
      link: 'tel:+254795568891'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      details: ['hfckenya@gmail.com'],
      link: 'https://mail.google.com/mail/?view=cm&fs=1&to=hfckenya@gmail.com'
    }
  ];

  return (
    <section id="contact" className="py-10 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-6 lg:mb-16">
          <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-100 text-red-700 rounded-lg text-[10px] lg:text-sm font-bold mb-2 lg:mb-4 uppercase tracking-wider">
            GET IN TOUCH
          </div>
          <h3 className="text-2xl lg:text-6xl font-black text-gray-900 mb-2 lg:mb-6">
            Visit <span className="text-red-600">HFC Gym</span> Today
          </h3>
          <p className="text-xs lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Stop by for a free tour and screening at one of Kenya's biggest and best-equipped gyms in Eldoret
          </p>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-6 mb-6 lg:mb-16">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-lg lg:rounded-2xl p-3 lg:p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-10 h-10 lg:w-14 lg:h-14 bg-gradient-to-br from-red-600 to-red-700 rounded-lg lg:rounded-xl flex items-center justify-center mb-2 lg:mb-4">
                <i className={`${info.icon} text-base lg:text-2xl text-white`}></i>
              </div>
              <h4 className="text-xs lg:text-lg font-bold text-gray-900 mb-1 lg:mb-3">{info.title}</h4>
              <div className="space-y-0.5 lg:space-y-1">
                {info.details.map((detail, idx) => (
                  <p key={idx} className="text-gray-600 text-[10px] lg:text-sm">
                    {detail}
                  </p>
                ))}
              </div>
              {info.link && (
                <a
                  href={info.link}
                  target={info.link.startsWith('http') ? '_blank' : undefined}
                  rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="inline-flex items-center gap-1 lg:gap-2 mt-2 lg:mt-4 text-red-600 font-semibold text-[10px] lg:text-sm hover:gap-2 lg:hover:gap-3 transition-all duration-300"
                >
                  <span>{info.link.startsWith('tel:') ? 'Call Now' : info.link.includes('mail.google.com') ? 'Send Email' : info.link.startsWith('mailto:') ? 'Send Email' : 'Get Directions'}</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              )}
            </div>
          ))}
        </div>

        {/* Map with Red Marker */}
        <div className="rounded-xl lg:rounded-3xl overflow-hidden shadow-xl h-[250px] lg:h-[600px]">
          <iframe
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=HFC+GYM+GO-DOWN+9+Lulumba+Ave+Eldoret+Kenya&zoom=16&maptype=roadmap"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="HFC Gym Location - Eldoret Kenya"
          ></iframe>
        </div>

        {/* Social Media Section */}
        <div className="text-center mt-8 lg:mt-16">
          <p className="text-gray-700 font-semibold mb-3 lg:mb-6 text-xs lg:text-base">Follow Us on Social Media</p>
          <div className="flex justify-center items-center gap-3 lg:gap-6">
            <a
              href="https://web.facebook.com/profile.php?id=61580676278232"
              target="_blank"
              rel="noopener noreferrer"
              className="relative w-10 h-10 lg:w-16 lg:h-16 bg-gradient-to-br from-red-600 to-red-800 hover:from-red-700 hover:to-red-900 rounded-xl lg:rounded-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl hover:shadow-red-600/30 group overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer-fast bg-[length:200%_100%] opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <i className="ri-facebook-fill text-white text-base lg:text-2xl relative z-10"></i>
            </a>
            <a
              href="https://www.instagram.com/HFC.Kenya"
              target="_blank"
              rel="noopener noreferrer"
              className="relative w-10 h-10 lg:w-16 lg:h-16 bg-gradient-to-br from-red-600 to-red-800 hover:from-red-700 hover:to-red-900 rounded-xl lg:rounded-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl hover:shadow-red-600/30 group overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer-fast bg-[length:200%_100%] opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <i className="ri-instagram-line text-white text-base lg:text-2xl relative z-10"></i>
            </a>
            <a
              href="https://www.tiktok.com/@hfc2025"
              target="_blank"
              rel="noopener noreferrer"
              className="relative w-10 h-10 lg:w-16 lg:h-16 bg-gradient-to-br from-gray-900 to-black hover:from-red-900 hover:to-black rounded-xl lg:rounded-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl hover:shadow-red-600/30 group overflow-hidden cursor-pointer border-2 border-red-600/30 hover:border-red-600"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer-fast bg-[length:200%_100%] opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <i className="ri-tiktok-line text-white text-base lg:text-2xl relative z-10"></i>
            </a>
            <a
              href="https://wa.me/254795568891"
              target="_blank"
              rel="noopener noreferrer"
              className="relative w-10 h-10 lg:w-16 lg:h-16 bg-gradient-to-br from-red-700 to-red-900 hover:from-red-800 hover:to-red-950 rounded-xl lg:rounded-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl hover:shadow-red-600/30 group overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer-fast bg-[length:200%_100%] opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <i className="ri-whatsapp-line text-white text-base lg:text-2xl relative z-10"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
